"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _ButtonGroup = require("../ButtonGroup/ButtonGroup.context");
var _ButtonIcon = require("../ButtonIcon/ButtonIcon");
var _Button = require("./Button.styles");
var _excluded = ["as", "buttonType", "children", "fluid", "icon", "iconPosition", "iconSize", "size", "disabled", "onClick"];
/**
 * @since 1.0.5
 */
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var as = _ref.as,
    buttonType = _ref.buttonType,
    children = _ref.children,
    fluid = _ref.fluid,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition,
    iconSize = _ref.iconSize,
    size = _ref.size,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_ButtonGroup.ButtonGroupContext);
  var buttonProps = Object.assign({
    as: as,
    buttonType: context.buttonType || buttonType,
    fluid: context.fluid || fluid,
    size: context.size || size,
    disabled: disabled,
    onClick: disabled ? null : onClick,
    ref: forwardedRef
  }, rest);
  var accessibilityProps = {
    'aria-disabled': disabled
  };
  if (disabled) {
    accessibilityProps.tabIndex = -1;
  }

  // Inputs do not allow icon children
  if (as === 'input') {
    return /*#__PURE__*/_react.default.createElement(_Button.StyledButton, buttonProps);
  }
  var buttonIconProps = {
    children: icon,
    iconPosition: iconPosition,
    iconSize: iconSize
  };
  return /*#__PURE__*/_react.default.createElement(_Button.StyledButton, (0, _extends2.default)({}, accessibilityProps, buttonProps), icon && iconPosition === 'start' ? /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, buttonIconProps) : null, children, icon && iconPosition === 'end' ? /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, buttonIconProps) : null);
});
exports.Button = Button;
Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node,
  /**
   * Set the button as disabled.
   */
  disabled: _propTypes.default.bool,
  /**
   * A fluid button will take up all horizontal space.
   * Can be inherited from a parent ButtonGroup.
   *
   * Supports inline media query objects
   */
  fluid: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * Add an `Icon` to the button.
   */
  icon: _propTypes.default.node,
  /**
   * Change the position of the `icon`.
   */
  iconPosition: _propTypes.default.oneOf(['start', 'end']),
  /**
   * This is not an exposed API property. It is only used internally.
   *
   * @ignore
   */
  iconSize: _propTypes.default.string,
  /**
   * Inverse colors for use on dark or colored backgrounds.
   */
  inverse: _propTypes.default.bool,
  /**
   * The size of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.BUTTON_SIZES)),
  /**
   * The type of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  buttonType: _propTypes.default.oneOf(Object.values(_constants.BUTTON_TYPES)),
  /**
   * Use the styled-components
   * [polymorphic "as" prop](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * to change the HTML tag of the component.
   *
   * This can be used to apply `Button` styling to HTML anchors, inputs, and custom components.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
} : {};
Button.defaultProps = {
  children: undefined,
  disabled: undefined,
  fluid: false,
  icon: undefined,
  iconPosition: 'start',
  iconSize: 'sm',
  inverse: false,
  size: _constants.BUTTON_SIZES.md,
  buttonType: _constants.BUTTON_TYPES.secondary,
  as: 'button'
};